import './jp-loading.less';

import type {IAttributes, IAugmentedJQuery, IScope} from 'angular';

/**
 * @ngdoc directive
 * @name jpLoading
 * @module portaro.directives
 *
 * @restrict EA
 *
 * @param {string=} jpLoading Size of spinner if directive is used as attribute.
 * @param {string=} size Size of spinner if directive is used as element.
 *
 * @description
 * Renders loading spinner. Possible values of size are: `md`, `xs`.
 */
export default class JpLoadingDirective {
    public static directiveName = 'jpLoading';

    public restrict = 'EA';
    public replace = false;
    public transclude = true;
    public scope = {};

    public templateUrl = require('./jp-loading.tpl.ftl');

    /*@ngInject*/
    constructor(private CONTEXT_PATH: string) {}

    public link($scope: JpLoadingScope, $element: IAugmentedJQuery, $attrs: IAttributes) {
        let size = 'md';

        if ($attrs[JpLoadingDirective.directiveName] && $attrs[JpLoadingDirective.directiveName].length > 0) {
            size = $attrs[JpLoadingDirective.directiveName];
        }

        if ($element[0].nodeName === 'JP-LOADING' && $attrs.size) {
            size = $attrs.size;
        }

        $scope.width = size === 'xs' ? 16 : 64;
        $scope.height = size === 'xs' ? 16 : 64;
        $scope.inline = $element[0].tagName === 'SPAN';
        $scope.imageSrc = `${this.CONTEXT_PATH}${require('./loading-spinner.svg')}`;
    }
}

interface JpLoadingScope extends IScope {
    width: number;
    height: number;
    inline: boolean;
    imageSrc: string;
}
